<template>
    <div id="app" class="bg flex flex--column" :class="[current, getCoverArtClass()]">
        <header class="logo">
            <Logo />
        </header>
        <main class="flex flex--column flex--center program">
            <div class="program__heading">
                <h1>Now on Air</h1>
            </div>

            <div class="flex flex--column flex--center program__body" v-if="current !== 'default'">
                <div class="flex flex--column flex--center">
                    <div class="blend program__name">
                        <h2 class="blend__text" v-text="programs[current].name"></h2>
                    </div>
                    <div class="blend program__dj">
                        <h3 class="blend__text" v-text="programs[current].dj"></h3>
                    </div>
                </div>
                <div class="program__schedule">
                    <span v-text="programs[current].schedule.display"></span>
                </div>
            </div>
            <div class="blend listen-live" v-else>
                <h2 class="blend__text">Listen live</h2>
            </div>
            <div class="player">
                <audio controls src="https://stream.canal90.fm/live" class="player"></audio>
            </div>

        </main>
        <footer class="footer">
            <div class="blend footer__one"></div>
            <div class="footer__two"></div>
            <div class="footer__three">
                <div class="flex flex--center social">
                    <a href="https://www.instagram.com/canal90fm" target=”_blank” title="Instragram page">
                        <svg class="svg-icon" viewBox="0 0 20 20">
                            <path fill="none" d="M14.52,2.469H5.482c-1.664,0-3.013,1.349-3.013,3.013v9.038c0,1.662,1.349,3.012,3.013,3.012h9.038c1.662,0,3.012-1.35,3.012-3.012V5.482C17.531,3.818,16.182,2.469,14.52,2.469 M13.012,4.729h2.26v2.259h-2.26V4.729z M10,6.988c1.664,0,3.012,1.349,3.012,3.012c0,1.664-1.348,3.013-3.012,3.013c-1.664,0-3.012-1.349-3.012-3.013C6.988,8.336,8.336,6.988,10,6.988 M16.025,14.52c0,0.831-0.676,1.506-1.506,1.506H5.482c-0.831,0-1.507-0.675-1.507-1.506V9.247h1.583C5.516,9.494,5.482,9.743,5.482,10c0,2.497,2.023,4.52,4.518,4.52c2.494,0,4.52-2.022,4.52-4.52c0-0.257-0.035-0.506-0.076-0.753h1.582V14.52z"></path>
                        </svg>
                    </a>
                    <a href="https://www.facebook.com/canal90fm" target=”_blank” title="Facebook page">
                        <svg class="svg-icon" viewBox="0 0 20 20">
                            <path fill="none" d="M11.344,5.71c0-0.73,0.074-1.122,1.199-1.122h1.502V1.871h-2.404c-2.886,0-3.903,1.36-3.903,3.646v1.765h-1.8V10h1.8v8.128h3.601V10h2.403l0.32-2.718h-2.724L11.344,5.71z"></path>
                        </svg>
                    </a>
                    <a href="mailto:hello@canal90fm.aw" title="E-mail us">
                        <svg class="svg-icon" viewBox="0 0 20 20">
                            <path d="M17.388,4.751H2.613c-0.213,0-0.389,0.175-0.389,0.389v9.72c0,0.216,0.175,0.389,0.389,0.389h14.775c0.214,0,0.389-0.173,0.389-0.389v-9.72C17.776,4.926,17.602,4.751,17.388,4.751 M16.448,5.53L10,11.984L3.552,5.53H16.448zM3.002,6.081l3.921,3.925l-3.921,3.925V6.081z M3.56,14.471l3.914-3.916l2.253,2.253c0.153,0.153,0.395,0.153,0.548,0l2.253-2.253l3.913,3.916H3.56z M16.999,13.931l-3.921-3.925l3.921-3.925V13.931z"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </footer>
        <div class="copyright"><small>&copy; Canal90 FM Aruba {{ new Date().getFullYear() }} | All Rights Reserved</small></div>
    </div>
</template>

<script>
import Logo from './components/Logo.vue'

export default {
    name: 'app',
    components: {
        Logo
    },
    data() {
        return {
            current: 'default',
            programs: {
                'morning-muse': { name: 'Morning Muse', dj: 'Julisa Hoevertsz', cover_art: 'sun-and-relax', schedule: { start: '10:01', end: '12:00', display: '10:00 - 12:00pm'}},
                'ivo-4-life': { name: 'IVO4LIFE', dj: 'Ivo Yanez', cover_art: 'boombox', schedule: { start: '14:20', end: '17:00', display: '2:20 - 5:00pm'}},
                'zayon-on-the-air': { name: 'Zayon on the Air', dj: 'Zayon Yanez', cover_art: 'couch', schedule: { start: '17:01', end: '19:00', display: '5:00 - 7:00pm'}}
            }
        }
    },
    methods: {
        showCurrentProgram: function(programs) {

            // Aruba timezone
            var timezone = 'America/Curacao';
            var now = this.$moment().tz(timezone);

            if (! now.isBusinessDay()) {
                this.current = 'default';

                return;
            }

            Object.keys(programs).every(function(index) {

                var stime = programs[index].schedule.start.split(':');
                var startTime = now.clone().hour(stime[0]).minute(stime[1]).seconds(0);

                var etime = programs[index].schedule.end.split(':');
                var endTime = now.clone().hour(etime[0]).minute(etime[1]).seconds(0);

                if(now.isBetween(startTime, endTime)) {
                    this.current = index;

                    return false;
                }

                this.current = 'default';

                return true;
            }, this);
        },

        getCoverArtClass: function() {
            if(this.current == 'default' ) {
                return "";
            }

            return this.programs[this.current].cover_art;
        }
    },
    mounted () {
        this.showCurrentProgram(this.programs);

        var that = this;
        // run the function every minute.
        this.$options.interval = setInterval( function() {
            that.showCurrentProgram(that.programs);
        }, 60000 );
    },
    beforeDestroy () {
        clearInterval(this.$options.interval);
    }
}
</script>

<style>
/* -----
SVG Icons - svgicons.sparkk.fr
----- */

.svg-icon {
  width: 2.5em;
  height: 2.5em;

  border-radius: 50%;
  border: 0.5em solid black;
  background-color: black;
  opacity: 0.4;
}

.svg-icon path,
.svg-icon polygon,
.svg-icon rect {
  fill: #f3921f;
}

.svg-icon circle {
  stroke: #f3921f;
  stroke-width: 1;
}

@media screen and (min-width: 1024px) {
    .svg-icon path,
    .svg-icon polygon,
    .svg-icon rect {
      fill: #fced0d;
    }

    .svg-icon circle {
      stroke: #fced0d;
    }
}

/****** BASE *******/
html, body {
    height: 100%;
}
body {
    margin:0;
}

audio {
    margin: 1em;
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100%;
}

/****** LAYOUT *******/
.flex {
    display: flex;
}
.flex--column {
    flex-direction: column;
}
.flex--center {
    align-items: center;
}

#app {
    min-height: 840px;
}

header,
footer {
    flex-shrink: 0;
}

main {
    flex-grow: 1;
}

.footer {
    display: flex;
    height: 90px;
}
.footer__one {
    width: 30px;
    background-color: #e63080;
}
.footer__two {
    width: 45px;
    background-color: #fced0d;
}
.footer__three {
    flex-grow: 1;
    background-color: #f3921f;
}

.social {
    height: 100%;
}
.social > a {
    margin: 10px;
}
.social > a:first-child {
    margin-left: 20px;
}

@media screen and (min-width: 1024px) {
    #app {
        flex-direction: row-reverse;
        align-items: stretch;
        flex-wrap: wrap;
        min-height: 740px;
    }
    .footer {
        height: 100%;
    }
    .footer__one {
        width: 60px;
    }
    .footer__two {
        width: 75px;
    }
    .footer__three {
        width: 350px;
    }
    .program,
    .program__body,
    .social {
        align-items: flex-start;
    }
    .program__body > div {
        flex-direction: row;
        flex-wrap: wrap;
    }
    .program__body > div:nth-child(3n) {
        flex-basis: 100%;
    }
    .social > a {
        margin-top: 100px;
    }
    .copyright {
        flex-basis: 100%;
    }
}

/****** STYLE *******/
.logo {
    width: 70%;
    margin: 0 auto;
}

.sun-and-relax #forthy_five .cls-12,
.sun-and-relax #yrs .cls-12,
.boombox #forthy_five .cls-12,
.boombox #yrs .cls-12 {
    fill: #fff;
}

.program__heading {
    background-color: #f3921f;
    color: #fff;
    margin-top: 2em;
}
.program__heading h1 {
    margin: 0.3em 0.1em;
    text-transform: uppercase;
}

.blend {
    position: relative;
}
.blend::before {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    background-color: #e63080;
    mix-blend-mode: multiply;
}
.blend--white::before {
    background-color: #fff;
}

.blend__text {
    z-index: 2;
    position: relative;
}
.listen-live > h2 {
    color: #fff;
    margin: 0.1em 0.3em;
}
.program__name > h2 {
    color: #fff;
    text-transform: uppercase;
    margin: 0.4em 0.5em;
}
.program__dj > h3 {
    color: #fff;
    font-weight: normal;
    margin: 0.1em 0.3em;
}
.program__schedule {
    background-color: white;
    opacity: 0.65;
    font-weight: bold;
}
.program__schedule > span {
    color: #000;
    margin: 0.1em 0.3em;
}

.bg {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;

}

.copyright {
    padding: 0.5em;
    background-color: white;
}

.default {
    background-image: url(./assets/default.jpg)
}
.boombox {
    background-image: url(./assets/boombox.jpg)
}
.sun-and-relax {
    background-image: url(./assets/sun-and-relax.jpg)
}
.move-to-the-beat {
    background-image: url(./assets/move-to-the-beat.jpg)
}
.couch {
    background-image: url(./assets/couch.jpg)
}

@media screen and (max-width: 1023px) {
    .logo {
        padding-top: 1em;
        padding-left: 20%;
    }
    .footer__one::before {
        mix-blend-mode: normal;
    }
}

@media screen and (min-width: 768px) {
    .program__heading > h1 {
        font-size: 4em;
    }
    .program__name > h2,
    .program__dj > h3,
    .listen-live > h2 {
        font-size: 2em;
    }
}

@media screen and (min-width: 1024px) {
    .logo {
        width: 35%;
        position: absolute;
        top: 80px;
        right: 80px;
        margin: 0;
    }

    .program__heading {
        margin-top: 350px;
        margin-left: -351px;
        z-index: 1;
    }
    .program__heading > h1 {
        margin-left: 361px;
    }
    .program__name > h2 {
        margin-right: 0.4em;
    }
    .program__dj > h3 {
        border-left: 2px solid white;
        padding-left: 0.4em;
        margin: 0.4em 0.2em 0.4em 0;
    }
    .program__schedule > span {
        margin-left: 1rem;
    }
    .listen-live > h2 {
        margin: 0.4em 0.2em;
    }
    audio {
        margin-left: 0;
    }

    .footer__one {
        background-color: transparent;
    }
    .footer__two {
        background-color: #f3921f;
    }
    .footer__three {
        background-color: #fced0d;
    }
}

@media screen and (min-width: 1300px) {
    .logo {
        width: 22.5%;
    }
}
</style>
